import React, { useEffect } from 'react';
import styles from '../dirigent/dirigent.module.css';

export default function Dirigent() {
  // Set the document title on component mount
  useEffect(() => {
    document.title = 'Dirigent';
  }, []);

  return (
    <main className={styles.main}>
        <section>
            <img src="/images/foto_dirigent.jpg" alt="foto Luc Schoeters" />
        </section>
        <section>
            <h1 className={styles.h1}>Luc Schoeters</h1>
            <p>
              Luc Schoeters (°1963) begon op 5 jarige leeftijd de bugel te bespelen.
              Alle opleidingen die Luc heeft doorlopen zijn steeds in privaat onderwijs verlopen en in de schoot van verenigingen onder begeleiding van privéleraars.
            </p>
            <p>
              Aanvankelijk begon hij zijn carrière op bugel en in 1992 schakelde hij over naar euphonium.  Momenteel kan je ook Luc aantreffen als muzikant op de tuba in diverse orkesten.
            </p>
            <p>
              In het verleden dirigeerde hij reeds verschillende orkesten.
              Binnen de Kon. Harmonie Musina te Muizen was hij gedurende 15 jaar dirigent tot 2014.
            </p>
            <p>
              Ook bij de K.F. De Vier Heemskinderen in Bertem en bij de K.F. Gevaertskring te Machelen was hij gedurende verschillende jaren dirigent.
              Bij de K.F. Albert te Hever was hij dirigent gedurende 10 jaar tussen 2010 en 2020 en na zijn dirigeerperiode werd hij daar voorzitter.
            </p>
            <p>
              Tijdens zijn carrière leidde hij diverse projecten zoals concerten in Barcelona, en themaconcerten zoals “Oorlog en Vrede” en Romeo en Julia bij de K.F. Albert te Hever.
            </p>
        </section>
    </main>
  );
}
